import { buildErrorMessage } from "@nimble/react-requests/helpers/error-message";
import { useMutation } from "@tanstack/react-query";

import useLastAuthMethod from "@/hooks/auth/use-last-auth-method";
import coreApiClient from "@/lib/api-clients/core-api-client";
import { AUTH_ERROR_MESSAGES } from "@/lib/constants/auth-messages";
import { AUTH_METHODS } from "@/lib/constants/auth-methods";

interface OTPVerifyRequest {
  email: string;
  token: string;
}

export default function useOTPVerify() {
  return useMutation({
    mutationFn: async ({ email, token }: OTPVerifyRequest) => {
      await coreApiClient
        .postApiAuthOtpVerify({
          body: { email, token },
        })
        .catch((error) => {
          throw new Error(
            buildErrorMessage(error, AUTH_ERROR_MESSAGES.otpVerifyFailed),
          );
        });
    },
    onSuccess: () =>
      useLastAuthMethod.getState().setLastAuthMethod(AUTH_METHODS.OTP),
  });
}
